import {PuiNetworkErrorPage, PuiNotFoundErrorPage, PuiServerErrorPage,} from "@portnet/ui";
import React from "react";
import {createBrowserRouter, Navigate} from "react-router-dom";
import ConsultationPackagesPage from "../../modules/packages/consultationPackages/page/ConsultationPackagesPage";
import DetailPackagePage from "../../modules/packages/detailPackage/page/DetailPackagePage";
import ModificationPackagePage from "../../modules/packages/modificationPackage/page/ModificationPackagePage";
import NouveauPackagePage from "../../modules/packages/nouveauPackage/page/NouveauPackagePage";
import ConsultationSouscriptionsPage
    from "../../modules/souscriptions/consultationSouscriptions/page/ConsultationSouscriptionsPage";
import DetailSouscription from "../../modules/souscriptions/detailsSouscription/page/DetailSouscription";
import NouvelleSouscriptionPage from "../../modules/souscriptions/nouvelleSouscription/page/NouvelleSouscriptionPage";
import ConsultationTransactionsPage
    from "../../modules/transactions/consultationTransactions/page/ConsultationTransactionsPage";
import AppMainContainer from "../components/general/AppMainContainer";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LoginPage from "../../modules/auth/login/page/LoginPage";
import PaiementSouscription from "../../modules/souscriptions/paiementSouscription/page/PaiementSouscription";
import {
  CONSULTATION_PACKAGES_PAGE_ROUTE,
  CONSULTATION_SOUSCRIPTIONS_PAGE_ROUTE,
  CONSULTATION_TRANSACTIONS_PAGE_ROUTE,
  DETAIL_CONSULTATION_PACKAGES_PAGE_ROUTE,
  DETAIL_SOUSCRIPTION_PAGE_ROUTE,
  GESTION_PACKAGES_PAGE_ROUTE,
  GESTION_SOUSCRIPTIONS_PAGE_ROUTE,
  LOGIN_PAGE_ROUTE,
  MODIFICATION_PACKAGE_PAGE_ROUTE,
  NETWORK_ERROR_PAGE_ROUTE,
  NOT_FOUND_ERROR_PAGE_ROUTE,
  NOUVEAU_PACKAGE_PAGE_ROUTE,
  NOUVELLE_SOUSCRIPTION_PAGE_ROUTE,
  PACKAGES_ROUTE_MODULE_KEY,
  PAIEMENT_SOUSCRIPTION_PAGE_ROUTE,
  ROOT_ROUTE,
  SERVER_ERROR_PAGE_ROUTE,
  SOUSCRIPTIONS_ROUTE_MODULE_KEY, SUCCESS_PAYMENT_PAGE_ERROR, SUCCESS_PAYMENT_PAGE_ROUTE,
  TRANSACTIONS_ROUTE_MODULE_KEY,
} from "../constants/routerConstants";
import ErrorPageContainer from "./components/ErrorPageContainer";
import {formatRoutes} from "./others/routerHelpers";
import SuccessPayment from "../components/ui/SuccessPayment";
import FailurePayment from "../components/ui/FailurePayment";


const router = createBrowserRouter(
  formatRoutes([
    {
      path: "*",
      element: <Navigate to={NOT_FOUND_ERROR_PAGE_ROUTE} replace />,
    },
    {
      path: "/",
      element: <AppMainContainer />,
      exact: true,
      children: [
        {
          path: SERVER_ERROR_PAGE_ROUTE,
          element: (
            <ErrorPageContainer>
              <PuiServerErrorPage />
            </ErrorPageContainer>
          ),
          exact: true,
        },
        {
          path: NOT_FOUND_ERROR_PAGE_ROUTE,
          element: (
            <ErrorPageContainer>
              <PuiNotFoundErrorPage />
            </ErrorPageContainer>
          ),
          exact: true,
        },
        {
          path: NETWORK_ERROR_PAGE_ROUTE,
          element: (
            <ErrorPageContainer>
              <PuiNetworkErrorPage />
            </ErrorPageContainer>
          ),
          exact: true,
        },
        {
          path: "",
          element: <Navigate to={LOGIN_PAGE_ROUTE} replace />,
          exact: true,
        },
        // Routes de bases
        /*----------------------------------------AUTH--------------------------------------------------*/
        {
          path: LOGIN_PAGE_ROUTE,
          element: <LoginPage />,
          isOnlyForPublic: true,
          exact: true,
        },
        {
          path: ROOT_ROUTE,
          element: <LoginPage />,
          isOnlyForPublic: true,
          exact: true,
        },
        /*--------------------------------------PACKAGES--------------------------------------------------*/
        {
          path: NOUVEAU_PACKAGE_PAGE_ROUTE,
          element: <NouveauPackagePage />,
          roles: ["ROLE_VUPORTUARIA_ADMIN_TARIF"],
          menu: {
            title: "Nouveau package",
            module: PACKAGES_ROUTE_MODULE_KEY,
            icon: AddCircleOutlineIcon,
          },
          isPrivate: true,
          exact: true,
        },
        {
          path: MODIFICATION_PACKAGE_PAGE_ROUTE,
          element: <ModificationPackagePage />,
          roles: ["ROLE_VUPORTUARIA_ADMIN_TARIF"],
          isPrivate: true,
          exact: true,
        },
        {
          path: CONSULTATION_PACKAGES_PAGE_ROUTE,
          element: <ConsultationPackagesPage type="consultation" />,
          menu: {
            title: "Consultation des packages",
            module: PACKAGES_ROUTE_MODULE_KEY,
            icon: VisibilityIcon,
          },
          isPrivate: true,
          exact: true,
        },
        {
          path: GESTION_PACKAGES_PAGE_ROUTE,
          element: <ConsultationPackagesPage type="gestion" />,
          roles: ["ROLE_VUPORTUARIA_ADMIN_TARIF"],
          menu: {
            title: "Gestion des packages",
            module: PACKAGES_ROUTE_MODULE_KEY,
            icon: ManageSearchIcon,
          },
          isPrivate: true,
          exact: true,
        },
        {
          path: DETAIL_CONSULTATION_PACKAGES_PAGE_ROUTE,
          element: <DetailPackagePage />,
          isPrivate: true,
          exact: true,
        },
        /*--------------------------------------TRANSACTIONS--------------------------------------------------*/
        {
          path: CONSULTATION_TRANSACTIONS_PAGE_ROUTE,
          element: <ConsultationTransactionsPage />,
          menu: {
            title: "Consultation des transactions",
            module: TRANSACTIONS_ROUTE_MODULE_KEY,
            icon: VisibilityIcon,
          },
          isPrivate: true,
          exact: true,
        },
        /*--------------------------------------SOUSCRIPTION--------------------------------------------------*/
        {
          path: PAIEMENT_SOUSCRIPTION_PAGE_ROUTE,
          element: <PaiementSouscription />,
          isPrivate: true,
        },
        {
          path: DETAIL_SOUSCRIPTION_PAGE_ROUTE,
          element: <DetailSouscription />,
          isPrivate: true,
        },
        {
          path: CONSULTATION_SOUSCRIPTIONS_PAGE_ROUTE,
          element: <ConsultationSouscriptionsPage type="consultation" />,
          menu: {
            title: "Consultation de mes forfaits",
            module: SOUSCRIPTIONS_ROUTE_MODULE_KEY,
            icon: VisibilityIcon,
          },
          isPrivate: true,
          exact: true,
        },
        {
          path: GESTION_SOUSCRIPTIONS_PAGE_ROUTE,
          element: <ConsultationSouscriptionsPage type="gestion" />,
          menu: {
            title: "Gestion de mes forfaits",
            module: SOUSCRIPTIONS_ROUTE_MODULE_KEY,
            icon: ManageSearchIcon,
          },
          roles: ["ROLE_VUPORTUARIA_ADMIN_TARIF"],
          isPrivate: true,
          exact: true,
        },
        {
          path: NOUVELLE_SOUSCRIPTION_PAGE_ROUTE,
          element: <NouvelleSouscriptionPage />,
          isPrivate: true,
          exact: true,
        },
        {
          path: SUCCESS_PAYMENT_PAGE_ROUTE, // Import SUCCESS_PAYMENT_PAGE_ROUTE from your constants file
          element: <SuccessPayment />,
          isPrivate: false, // Depending on your authentication logic
          exact: true,
        },
        {
          path: SUCCESS_PAYMENT_PAGE_ERROR, // Import SUCCESS_PAYMENT_PAGE_ROUTE from your constants file
          element: <FailurePayment />,
          isPrivate: false, // Depending on your authentication logic
          exact: true,
        },
      ],
    },
  ])
);

export default router;
